module.exports = __webpack_public_path__ + "static/media/Паспорт GALAD Иллюминатор LED.2d09543b.pdf";